import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://swxxutvpafwxwzrtwzjd.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN3eHh1dHZwYWZ3eHd6cnR3empkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgyNDc1NDMsImV4cCI6MjA5MzgyMzU0M30.bQIsuXr2lLk20fnElDslW5FLS-jbHLLjBCTpRYpQPzQ'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
